import { useState, type FormEvent } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import "../components/AuthForm.css";

export function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) {
      // Honor the "intended destination" from a RequireAuth redirect, else
      // send the user to the authenticated landing page.
      const dest = (location.state as { from?: string } | null)?.from ?? "/dashboard";
      navigate(dest);
    } else {
      setError(res.message);
    }
  }

  return (
    <section className="auth-shell container">
      <div className="auth-card card">
        <h1>Welcome back</h1>
        <p className="auth-card__sub">Sign in to your SilicoInformatics account.</p>
        <form className="form" onSubmit={onSubmit}>
          {error && <div className="form__alert" role="alert">{error}</div>}
          <div className="field">
            <label htmlFor="email">Email</label>
            <input
              id="email" type="email" autoComplete="email" required
              value={email} onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="password">Password</label>
            <input
              id="password" type="password" autoComplete="current-password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Link to="/forgot-password" style={{ fontSize: "var(--fs-small)" }}>Forgot password?</Link>
          </div>
          <button type="submit" className="btn btn--primary" disabled={submitting}>
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <div className="form__divider" role="separator" aria-label="or">
          <span>New to SilicoInformatics?</span>
        </div>
        <Link to="/signup" className="btn btn--ghost form__alt-cta">
          Create an account
        </Link>
      </div>
    </section>
  );
}
